/**
 * Support Selectors
 * NgRx selectors for accessing support state
 */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupportState } from '../models/support.models';

export const selectSupportState = createFeatureSelector<SupportState>('support');

export const selectTickets = createSelector(selectSupportState, (state) => state.tickets);
export const selectSelectedTicket = createSelector(selectSupportState, (state) => state.selectedTicket);
export const selectStats = createSelector(selectSupportState, (state) => state.stats);
export const selectFilters = createSelector(selectSupportState, (state) => state.filters);
export const selectTotalTickets = createSelector(selectSupportState, (state) => state.totalTickets);
export const selectCurrentPage = createSelector(selectSupportState, (state) => state.currentPage);
export const selectPageSize = createSelector(selectSupportState, (state) => state.pageSize);
export const selectLoading = createSelector(selectSupportState, (state) => state.loading);
export const selectSubmitting = createSelector(selectSupportState, (state) => state.submitting);
export const selectError = createSelector(selectSupportState, (state) => state.error);
export const selectSuccessMessage = createSelector(selectSupportState, (state) => state.successMessage);

export const selectTotalPages = createSelector(
  selectTotalTickets,
  selectPageSize,
  (total, pageSize) => Math.ceil(total / pageSize)
);

